<template>
  <div class="growth-book-index">
    <el-row style="padding-bottom: 10px;border-bottom: 1px solid #e4e7ed;">
      <el-col :span="24">
        <el-button
          type="primary"
          size="medium"
          @click="gotoForm"
        >新增组件</el-button>
        <el-select
          size="medium"
          placeholder="请选择"
          value-key="code"
          v-model="form.type"
          @change="handleType"
        >
          <el-option
            :label="type.value"
            :value="type"
            :key="typeIdx"
            v-for="(type, typeIdx) in typeList"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="content-wrapper" :style="`height: ${windowHeight-180}px;overflow: auto;`">
      <div
        class="no-list-msg"
        v-if="isEmpty"
      >
        <img
          src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
          alt
        />
        <div>暂无数据</div>
      </div>
      <div
        class="template-wrapper"
        v-else
        v-loading="tabLoading"
      >
        <div
          class="template-item"
          :key="idx"
          v-for="(item, idx) in tabList"
        >
          <div class="handle-wrapper">
            <i
              class="el-icon-edit"
              style="color: #409EFF;"
              @click="gotoForm(item)"
            ></i>
            <i
              class="el-icon-delete"
              style="margin-left: 10px;color: #F56C6C;"
              @click="handleDelete(item)"
            ></i>
          </div>
          <img
            :src="item.backLogo"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* utils */
import mixin from "@/mixins/windowResize";
import { mapGetters } from "vuex";

/* components */
import { findDicsByCode } from "@/api/common/common";
import {
  getGrowthBookAssemblyList,
  deleteGrowthBookAssemblyById,
} from "@/api/growthBook";

/* api */

export default {
  mixins: [mixin],
  components: {},
  computed: {
    ...mapGetters(["userInfo"]),
  },
  filters: {},
  data() {
    return {
      // 列表数据是否为空
      isEmpty: false,
      // 类型筛选列表
      typeList: [],
      // 列表数据加载中
      tabLoading: false,
      // 列表数据
      tabList: [],
      // 请求表单
      form: {
        type: {
          code: "",
        },
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let p = Promise.all([this.findDicsByCode()])
        .then((res) => {
          this.getGrowthBookAssemblyList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    findDicsByCode() {
      return findDicsByCode({
        dicCode: "archivesActivityType",
      })
        .then((res) => {
          let _res = res.data;
          if (_res.code != 200) return Promise.reject(_res.msg);
          else return _res.data;
        })
        .then((data) => {
          if (Array.isArray(data)) {
            this.typeList = [
              { code: "", value: "全部组件类型" },
              ...data.map((item) => JSON.parse(JSON.stringify(item))),
            ];
          }
        });
    },
    getGrowthBookAssemblyList() {
      this.tabLoading = true;
      getGrowthBookAssemblyList({
        typeCode: this.form.type.code,
      }).then((data) => {
        if (Array.isArray(data)) {
          this.tabList = data.map((item) => JSON.parse(JSON.stringify(item)));
          this.isEmpty = this.tabList.length == 0;
        } else {
          this.isEmpty = true;
        }
        this.tabLoading = false;
      });
    },
    deleteGrowthBookAssemblyById(form) {
      deleteGrowthBookAssemblyById(form)
        .then((data) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getGrowthBookAssemblyList();
        })
        .catch((msg) => {
          this.$message({
            message: msg,
            type: "error",
          });
        });
    },
    // 点击*删除*
    handleDelete(item) {
      this.$confirm("确认要删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
        lockScroll: false,
      })
        .then(() => {
          let form = {
            id: item.id,
          };
          this.deleteGrowthBookAssemblyById(form);
        })
        .catch(() => {});
    },
    // type 改变
    handleType() {
      this.getGrowthBookAssemblyList();
    },
    // 新增 & 编辑 组件
    gotoForm(item) {
      const routeParams = {
        path: "form",
      };
      if (item) routeParams.query = { id: item.id };
      this.$router.push(routeParams);
    },
  },
};
</script>
<style lang="scss" scoped>
.growth-book-index {
  height: 100%;
  padding:12px;
  box-sizing: border-box;
  .el-table__body-wrapper {
    .delete-btn {
      color: #f56c6c;
    }
  }

  // 暂无数据
  .no-list-msg {
    font-size: 14px;
    text-align: center;
    color: #999;
    overflow: hidden;
    img {
      margin-top: 50px;
    }
    div {
      margin-top: -50px;
    }
  }

  .content-wrapper {
    height: calc(100% - 57px);
    box-sizing: border-box;
    .template-wrapper {
      padding: 10px 15px 15px 15px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      .template-item {
        flex: 0 0 200px;
        width: 200px;
        height: 282px;
        margin-right: 15px;
        margin-bottom: 15px;
        position: relative;
        transition: box-shadow 0.3s linear;
        .handle-wrapper {
          position: absolute;
          top: 10px;
          right: 10px;
          font-size: 18px;
          i {
            cursor: pointer;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        &:hover {
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.4);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/growthBook/index.vue